var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"white-color"},[_vm._v(" This page is under construction! ")])}
var staticRenderFns = []

export { render, staticRenderFns }